import { useEffect, useState } from "react";
import "../../styles/ThirdParty/Validation.scss";
import {
  getPlantsData as greenBasicGetAllEmissionData,
  getStaticAttributes as greenBasicGetStaticAttributes,
} from "../../instantiateTransaction/basicGreenProject";
import {
  getPlantsData as infraBasicGetAllEmissionData,
  getStaticAttributes as infraBasicGetStaticAttributes,
} from "../../instantiateTransaction/basicInfrastructureChange";
import {
  getPlantsData as greenGovernanceGetAllEmissionData,
  getStaticAttributes as greenGovernanceGetStaticAttributes,
} from "../../instantiateTransaction/governanceGreenProject";
import {
  getPlantsData as governanceInfraGetAllEmissionData,
  getStaticAttributes as governanceInfraGetStaticAttributes,
} from "../../instantiateTransaction/gorvernanceInfrastructureChange";
import {
  getPlantsData as governanceMonitoringGetAllEmissionData,
  getStaticAttributes as governanceMonitoringGetStaticAttributes,
} from "../../instantiateTransaction/governanceCarbonMonitoring";
import {
  getFacilityData,
  updateUserKyc,
} from "../../apis/AdminDashboard/users";
import { toast } from "react-toastify";
import { ethers } from "ethers";
import { useQuery } from "@tanstack/react-query";

import {
  getDatabase,
  ref,
  onValue,
  push,
  orderByChild,
  equalTo,
  query,
  update,
} from "firebase/database";
import axios from "axios";
import { useRef } from "react";
import moment from "moment";
import { facilityValidate } from "../../apis/General/web3/shared";
import { useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Illustration from "../../images/9264828.jpg";
import ReactQuill from "react-quill";
import { getKyc, getUserInfo } from "../../apis/General/users";
import { Link, useNavigate, useParams } from "react-router-dom";
import Kyc from "../../components/ThirdPartyDashboard/Kyc";
import SideBar from "../../components/AdminDashboard/SideBar";
import { Tab, Tabs } from "@mui/material";
import Search from "../../components/AdminDashboard/Search";
import { createComment } from "../../apis/ThirdPartyDashboard/dashboard";
import pfd from "../../images/pdf.png";

const DocumentUploadField = ({
  label,
  fileName = "Document",
  fileInfo = "0MB of 5MB",
  isLoading,
  isUploaded,
  onClear,
  inputRef,
}) => {
  return (
    <div className="flex flex-col gap-2 mb-6">
      <label className="block text-[14px] font-[400] text-[#101828] w-[235px] flex-shrink-0">
        {label}
      </label>
      <div
        className="w-[552px] h-[120px] bg-white border-[0.5px] border-dashed border-[#667185] rounded-lg relative flex flex-col justify-center px-6 cursor-pointer"
        onClick={() => inputRef.current?.click()}
      >
        {(isUploaded || isLoading) && (
          <button
            className="absolute top-4 right-4 w-6 h-6 flex items-center justify-center text-[#667185] hover:text-black"
            onClick={(e) => {
              e.stopPropagation();
              onClear();
            }}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 6L6 18M6 6l12 12"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        )}

        <div className="flex items-start gap-4">
          <div className="w-8 h-9 flex items-center justify-center bg-gray-100 rounded">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V12L13 2Z"
                stroke="#667185"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          <div className="flex flex-col">
            <span className="font-['Inter'] font-medium text-[14px] leading-[21px] text-[#101828]">
              {isUploaded || isLoading ? fileName : "Choose file to upload"}
            </span>

            <div className="flex items-center gap-2 mt-1">
              <span className="font-['Inter'] font-normal text-[12px] leading-[18px] text-[#667185]">
                {isLoading ? "Uploading..." : isUploaded ? fileInfo : ""}
              </span>
            </div>
          </div>
        </div>

        {isLoading && (
          <div className="absolute left-6 right-6 bottom-6 w-[504px] h-[8px] bg-[#F9F9F9] rounded-full overflow-hidden">
            <div
              className="h-full bg-[#038B47] rounded-full transition-all duration-300"
              style={{ width: "40%" }}
            ></div>
          </div>
        )}
      </div>
      <input type="file" hidden ref={inputRef} onChange={() => {}} />
    </div>
  );
};

const Validation = () => {
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);
  const token = auth?.token;
  console.log("auth", auth);
  const pathname = useParams();
  const mediaRef = useRef(null);

  const [modalOpen, setModalOpen] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [validateLoading, setValidateLoading] = useState(false);
  const [rejectLoading, setRejectLoading] = useState(false);
  const [activities, setActivities] = useState([]);
  // const [loading, setLoading] = useState(false);
  const [facilityLoading, setFacilityLoading] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [selectedFacility, setSelectedFacility] = useState(null);
  const [content, setContent] = useState("");
  const [projectDescription, setProjectDescription] = useState("");
  const [quantifiedBaseYearInventory, setQuantifiedBaseYearInventory] =
    useState("");
  const [quantificationMethodology, setQuantificationMethodology] =
    useState("");
  const [selectedStaticAttributes, setSelectedStaticAttributes] =
    useState(null);
  const [selectedId, setSelectedId] = useState("");
  const [selectedKyc, setSelectedKyc] = useState("");
  const [reason, setReason] = useState("");
  const [value, setValue] = useState(0);
  const [facilityType, setFacilityType] = useState("green");
  const [greenBasicFacilitiesValidated, setGreenBasicFacilitiesValidated] =
    useState([]);
  const [greenBasicFacilitiesUnvalidated, setGreenBasicFacilitiesUnvalidated] =
    useState([]);
  const [infraBasicFacilitiesValidated, setInfraBasicFacilitiesValidated] =
    useState([]);
  const [infraBasicFacilitiesUnvalidated, setInfraBasicFacilitiesUnvalidated] =
    useState([]);
  const [
    greenGovernanceFacilitiesValidated,
    setGreenGovernanceFacilitiesValidated,
  ] = useState([]);
  const [
    greenGovernanceFacilitiesUnvalidated,
    setGreenGovernanceFacilitiesUnvalidated,
  ] = useState([]);
  const [
    infraGovernanceFacilitiesValidated,
    setInfraGovernanceFacilitiesValidated,
  ] = useState([]);
  const [
    infraGovernanceFacilitiesUnvalidated,
    setInfraGovernanceFacilitiesUnvalidated,
  ] = useState([]);
  const [selectedSubscriptionPlan, setSelectedSubscriptionPlan] = useState("");
  const [monitoringValidated, setMonitoringValidated] = useState([]);
  const [monitoringUnvalidated, setMonitoringUnvalidated] = useState([]);
  const [validatedLength, setValidatedLength] = useState(0);
  const [unValidatedLength, setUnValidatedLength] = useState(0);
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [scenario, setScenario] = useState("");
  const [organizationDescription, setOrganizationDescription] = useState("");
  const [publicKey, setPublicKey] = useState("");
  const [location, setLocation] = useState("");
  const [subscription, setSubscription] = useState("");
  const [fuelSource, setFuelSource] = useState("");
  const [renewableEnergySolutions, setRenewableEnergySolutions] = useState("");
  const [governmentOrganization, setGovernmentOrganization] = useState("");
  const [regulatoryStatus, setRegulatoryStatus] = useState("");
  const [images, setImages] = useState([]);
  const [uplaodLoading, setUploadLoading] = useState(false);
  const [kycKeys, setKycKeys] = useState([]);
  const [quantificationFile, setQuantificationFile] = useState(null);
  const [projectDesignFile, setProjectDesignFile] = useState(null);
  const [quantificationProgress, setQuantificationProgress] = useState(0);
  const [projectDesignProgress, setProjectDesignProgress] = useState(0);
  const [openTabKey, setOpenTabKey] = useState(null);
  // ---- File → base64 helper ----
  const fileToUri = (file, cb) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => cb(null, reader.result);
    reader.onerror = (err) => cb(err, null);
  };

  const openTabSection = (facilityType, index) => {
    const tabKey = `${facilityType}-${index}`;
    setOpenTabKey((currentKey) => (currentKey === tabKey ? null : tabKey));
  };
  // ---- Core upload: accepts the File object directly + a "qm" | "pdd" tag ----
  const uploadDocument = (file, documentType) => {
    if (!(file instanceof Blob)) return;

    const isPdd = documentType === "pdd";
    const setProgress = isPdd
      ? setProjectDesignProgress
      : setQuantificationProgress;

    // reset and kick off a new upload
    setProgress(0);
    setUploadLoading(true);

    fileToUri(file, (err, result) => {
      if (err || !result) {
        setProgress(0);
        setUploadLoading(false);
        return;
      }

      axios
        .post(
          `${process.env.REACT_APP_API_URL}/open/v1/upload`,
          {
            media_type: "docx",
            folder: "word_documents",
            user_id: auth?.userInfo?.id,
            contents: [result],
          },
          {
            headers: {
              Authorization: `Bearer ${auth?.token || ""}`,
            },
            onUploadProgress: (evt) => {
              if (!evt.total) return;
              const pct = Math.round((evt.loaded * 100) / evt.total);
              // ⬇️ monotonic: progress never moves backwards
              setProgress((prev) => Math.max(prev, pct));
            },
          },
        )
        .then((response) => {
          // force-complete: keeps the bar fully green
          setProgress(100);
          setQuantificationMethodology(response?.data?.body?.data[0]);
          setUploadLoading(false);
        })
        .catch((err) => {
          console.log("UPLOAD ERROR", err);
          // on failure keep whatever progress was reached;
          // reset only if you want a visual failure cue
          setUploadLoading(false);
        });
    });
  };

  const handleQuantificationUpload = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setQuantificationFile(file);
    uploadDocument(file, "qm");
  };

  const handleProjectDesignUpload = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setProjectDesignFile(file);
    uploadDocument(file, "pdd");
  };

  // kyc green data
  const {
    data: greenFacilities = [],
    isLoading: loading,
    isError,
    error,
  } = useQuery({
    queryKey: ["facilities-kyc", token],
    queryFn: ({ signal }) => getFacilityData({ token, signal }),
    enabled: Boolean(token),
    staleTime: 60_000,
    retry: 1,
    refetchOnWindowFocus: false,
    select: (res) =>
      (res?.message?.facilities ?? []).filter(
        (f) => f?.facilityCategory === "green",
      ),
  });
  console.log("facilities-kyc", greenFacilities);
  // perform kyc total
const { data: kycTotal = 0 } = useQuery({
  queryKey: ["facilities-kyc-total", token],
  queryFn: ({ signal }) => getFacilityData({ token, signal }),
  enabled: Boolean(token),
  staleTime: 60_000,
  retry: 1,
  refetchOnWindowFocus: false,
  select: (res) => (res?.message?.facilities ?? []).length,
});
console.log("facilities-kyc-total", kycTotal); // number
  // kyc non-green data
  const {
    data: greenFacilitiesNonGreen = [],
    // isPending,
    // isError,
    // error,
  } = useQuery({
    queryKey: ["facilities-kyc", token],
    queryFn: ({ signal }) => getFacilityData({ token, signal }),
    enabled: Boolean(token),
    staleTime: 60_000,
    retry: 1,
    refetchOnWindowFocus: false,
    select: (res) =>
      (res?.message?.facilities ?? []).filter(
        (f) => f?.facilityCategory === "non-green",
      ),
  });
  console.log("facilities-kyc-nongreen", greenFacilitiesNonGreen);

  // carbon monitooring data
  const {
    data: carbonMonitoringData = [],
    // isPending,
    // isError,
    // error,
  } = useQuery({
    queryKey: ["facilities-kyc", token],
    queryFn: ({ signal }) => getFacilityData({ token, signal }),
    enabled: Boolean(token),
    staleTime: 60_000,
    retry: 1,
    refetchOnWindowFocus: false,
    select: (res) =>
      (res?.message?.facilities ?? []).filter(
        (f) =>
          f?.status === "pending" &&
          f?.facilityCategory === "carbon-monitoring",
      ),
  });
  console.log("carbon-monitoring-data", carbonMonitoringData);
  // Unvalidated project data green
  const {
    data: unvalidatedProjectData = [],
    // isPending,
    // isError,
    // error,
  } = useQuery({
    queryKey: ["facilities-kyc", token],
    queryFn: ({ signal }) => getFacilityData({ token, signal }),
    enabled: Boolean(token),
    staleTime: 60_000,
    retry: 1,
    refetchOnWindowFocus: false,
    select: (res) =>
      (res?.message?.facilities ?? []).filter(
        (f) => f?.status === "adminApproved" && f?.facilityCategory === "green",
      ),
  });
  console.log("unvalidated-project-data", unvalidatedProjectData);
  // Unvalidated project data non-green
  const {
    data: unvalidatedProjectDataNonGreen = [],
    // isPending,
    // isError,
    // error,
  } = useQuery({
    queryKey: ["facilities-kyc", token],
    queryFn: ({ signal }) => getFacilityData({ token, signal }),
    enabled: Boolean(token),
    staleTime: 60_000,
    retry: 1,
    refetchOnWindowFocus: false,
    select: (res) =>
      (res?.message?.facilities ?? []).filter(
        (f) =>
          f?.status === "adminApproved" && f?.facilityCategory === "non-green",
      ),
  });
  console.log(
    "unvalidated-project-data-non-green",
    unvalidatedProjectDataNonGreen,
  );
  // Unvalidated project data non-green
  const {
    data: unvalidatedProjectDataCarbonMonitoring = [],
    // isPending,
    // isError,
    // error,
  } = useQuery({
    queryKey: ["facilities-kyc", token],
    queryFn: ({ signal }) => getFacilityData({ token, signal }),
    enabled: Boolean(token),
    staleTime: 60_000,
    retry: 1,
    refetchOnWindowFocus: false,
    select: (res) =>
      (res?.message?.facilities ?? []).filter(
        (f) =>
          f?.status === "adminApproved" && f?.facilityCategory === "non-green",
      ),
  });
  console.log(
    "unvalidated-project-data-carbon-monitoring",
    unvalidatedProjectDataCarbonMonitoring,
  );

  // validated project data green
  const {
    data: validatedProjectData = [],
    // isError,
    // error,
  } = useQuery({
    queryKey: ["facilities-kyc", token],
    queryFn: ({ signal }) => getFacilityData({ token, signal }),
    enabled: Boolean(token),
    staleTime: 60_000,
    retry: 1,
    refetchOnWindowFocus: false,
    select: (res) =>
      (res?.message?.facilities ?? []).filter(
        (f) => f?.status === "completed" && f?.facilityCategory === "green",
      ),
  });
  console.log("validated-project-data", validatedProjectData);

  // validated project data non-green
  const {
    data: validatedProjectDataNonGreen = [],
    // isPending,
    // isError,
    // error,
  } = useQuery({
    queryKey: ["facilities-kyc", token],
    queryFn: ({ signal }) => getFacilityData({ token, signal }),
    enabled: Boolean(token),
    staleTime: 60_000,
    retry: 1,
    refetchOnWindowFocus: false,
    select: (res) =>
      (res?.message?.facilities ?? []).filter(
        (f) => f?.status === "completed" && f?.facilityCategory === "non-green",
      ),
  });
  console.log("validated-project-data-non-green", validatedProjectDataNonGreen);

  // greenFacilitiesNonGreen is already green-only
  // const kycforgreen = greenFacilitiesNonGreen.filter(
  //   (f) => f.facilityCategory === "green" && f.status === "pending",
  // );
  // console.log("kycforgreen", kycforgreen);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showUploadDocument, setShowUploadDocument] = useState(false);

  const [selectedReason, setSelectedReason] = useState("");
  const [selectedChecks, setSelectedChecks] = useState([]);
  const [additionalComment, setAdditionalInfo] = useState("");
  // const [kycGreenData , setKycGreenData] = useState([]);

  const selectedKycID = selectedKyc;
  console.log(selectedKycID);
  const handleCommentUpload = async (e) => {
    e.preventDefault();
    const kycComment = await createComment(
      additionalComment,
      selectedReason,
      token,
      selectedKycID,
    );
    console.log("kycComment", kycComment);
  };

  const toggleCheck = (value) => {
    setSelectedChecks((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value],
    );
  };
  const db = getDatabase();
  const tableRef = ref(db, "kycStatus");

  const a11yProps = (index) => ({
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  });

  const handleTabChange = (event, newValue) => {
    console.log("newValue", newValue);
    setValue(newValue);
  };

  const handleModalOpen = async (facility, index, subscriptionPlan) => {
    setCurrentIndex(index);
    // loading;
    setSelectedSubscriptionPlan(subscriptionPlan);

    try {
      console.log(
        "facility",
        facility,
        "subscriptionPlan",
        subscriptionPlan,
        facility?.scenario,
        facility?.scenario === "infrastructure-change",
      );
      setSelectedFacility(facility);

      let response;
      if (facility?.scenario === "non-green" && subscriptionPlan === "basic") {
        console.log("Case: non-green + basic");
        response = await infraBasicGetStaticAttributes(facility?.plantAddress);
      } else if (
        facility?.scenario === "green" &&
        subscriptionPlan === "basic"
      ) {
        console.log("Case: green + basic");
        response = await greenBasicGetStaticAttributes(facility?.plantAddress);
      } else if (
        facility?.scenario === "non-green" &&
        subscriptionPlan === "governance"
      ) {
        console.log("Case: non-green + governance");
        response = await governanceInfraGetStaticAttributes(
          facility?.plantAddress,
        );
      } else if (
        facility?.scenario === "green" &&
        subscriptionPlan === "governance"
      ) {
        console.log("Case: green + governance");
        response = await greenGovernanceGetStaticAttributes(
          facility?.plantAddress,
        );
      } else if (facility?.scenario === "carbon-monitoring") {
        console.log("Case: carbon-monitoring");
        response = await governanceMonitoringGetStaticAttributes(
          facility?.plantAddress,
        );
      } else {
        alert("Invalid Scenario");
        return;
      }

      console.log("response static", response);

      const userId =
        facility?.scenario === "green" && subscriptionPlan === "basic"
          ? response?.staticAttributes[5]
          : facility?.scenario === "non-green" && subscriptionPlan === "basic"
          ? response?.staticAttributes[6]
          : facility?.scenario === "green" && subscriptionPlan === "governance"
          ? response?.staticAttributes[7]
          : facility?.scenario === "non-green" &&
            subscriptionPlan === "governance"
          ? response?.staticAttributes[7]
          : response?.staticAttributes[7];




// get by id 
// const GetDataById = (id) => {
//   const {
//     data: validatedProjectDataNonGreen = [],
//     isPending,
//     isError,
//     error,
//   } = useQuery({
//     // ✅ Include `id` in the query key so cache is scoped per id
//     queryKey: ["facilities-kyc", id, token],
//     queryFn: ({ signal }) =>
//       getFacilityData({ id, token, signal }), // ✅ pass id to fetcher
//     enabled: Boolean(id) && Boolean(token),   // ✅ only run when id + token exist
//     staleTime: 60_000,
//     retry: 1,
//     refetchOnWindowFocus: false,
//     select: (res) =>
//       (res?.message?.facilities ?? []).filter(
//         (f) =>
//           f?.status === "completed" &&
//           f?.facilityCategory === "non-green" &&
//           // (optional) if the API returns mixed data and you need to filter by id:
//           String(f?.walletAddress) === String(id)
//       ),
//   });

//   console.log("validated-project-data-non-green", id, validatedProjectDataNonGreen);

//   return { validatedProjectDataNonGreen, isPending, isError, error };
// };

      const [userInfoResponse, kycResponse] = await Promise.all([
        getUserInfo(userId, auth?.token),
        getKyc(userId, auth?.token),
      ]);

      console.log("userInfoResponse", userInfoResponse);
      console.log("kycResponse", kycResponse);

      setEmail(userInfoResponse?.data?.message?.email);
      setFirstName(userInfoResponse?.data?.message?.firstName);
      setLastName(userInfoResponse?.data?.message?.lastName);
      setCompanyName(userInfoResponse?.data?.message?.companyName);

      setSelectedStaticAttributes(response?.staticAttributes);
      setSelectedKyc(kycResponse?.data?.message);
      console.log("setSelectedKyc", setSelectedKyc);
      setQuantificationMethodology(
        kycResponse?.data?.message?.quantificationMethodology || "",
      );

      setSelectedId(userId);
      setShowForm(true);
    } catch (error) {
      console.log("ERROR", error);
      toast.error("Something went wrong");
    }
    setFacilityLoading(false);
  };

  const handleModalClose = (e) => {
    if (e.target.classList.contains("modal")) {
      setModalOpen(false);
    }
  };

  const getValidationData = async () => {
    // setLoading(true);

    try {
      const response6 = await greenBasicGetAllEmissionData(0, 20);
      console.log("response6", response6);

      const temp1 = response6?.getAllInfo?.filter(
        (item) => !!item?.isValidated,
      );
      const temp2 = response6?.getAllInfo?.filter((item) => !item?.isValidated);
      setGreenBasicFacilitiesValidated(temp1);
      setGreenBasicFacilitiesUnvalidated(temp2);

      const response7 = await infraBasicGetAllEmissionData(0, 20);
      console.log("response7", response7);

      const temp3 = response7?.getAllInfo?.filter(
        (item) => !!item?.isValidated,
      );
      const temp4 = response7?.getAllInfo?.filter((item) => !item?.isValidated);

      setInfraBasicFacilitiesValidated(temp3);
      setInfraBasicFacilitiesUnvalidated(temp4);

      const response8 = await greenGovernanceGetAllEmissionData(0, 20);
      console.log("response8", response8);

      const temp5 = response8?.getAllInfo?.filter(
        (item) => !!item?.isValidated,
      );
      const temp6 = response8?.getAllInfo?.filter((item) => !item?.isValidated);

      setGreenGovernanceFacilitiesValidated(temp5);
      setGreenGovernanceFacilitiesUnvalidated(temp6);

      const response9 = await governanceInfraGetAllEmissionData(0, 20);
      console.log("response9", response9);

      const temp7 = response9?.getAllInfo?.filter(
        (item) => !!item?.isValidated,
      );
      const temp8 = response9?.getAllInfo?.filter((item) => !item?.isValidated);

      setInfraGovernanceFacilitiesValidated(temp7);
      setInfraGovernanceFacilitiesUnvalidated(temp8);

      const response10 = await governanceMonitoringGetAllEmissionData(0, 20);
      console.log("response10", response10);

      const temp9 = response10?.getAllInfo?.filter(
        (item) => !!item?.isValidated,
      );
      const temp10 = response10?.getAllInfo?.filter(
        (item) => !item?.isValidated,
      );

      setMonitoringValidated(temp9);
      setMonitoringUnvalidated(temp10);

      setValidatedLength(
        temp1?.length +
          temp3?.length +
          temp5?.length +
          temp7?.length +
          temp9?.length,
      );

      setUnValidatedLength(
        temp2?.length +
          temp4?.length +
          temp6?.length +
          temp8?.length +
          temp10?.length,
      );
    } catch (error) {
      console.log("ERROR FROM FRONTEND", error);
    }
    // setLoading(false);
  };

  const getActivities = async () => {
    const database = getDatabase();

    const newRef = ref(database, "events");
    await onValue(newRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setActivities(Object.values(data));
      }
    });
  };

  useEffect(() => {
    getValidationData();
    getActivities();
  }, []);

  const getLastActivity = (address) => {
    if (!activities || activities.length === 0) {
      return "Loading...";
    }

    console.log("Checking activities for address:", address);

    const filteredData = activities?.filter(
      (item) =>
        item?.addressToRecord === address && item?.type === "Plant Validated",
    );

    console.log("Filtered activities for address:", address, filteredData);

    if (filteredData?.length > 0) {
      const lastData = filteredData[filteredData.length - 1];
      console.log("Last validation data:", lastData);

      return moment(parseInt(lastData?.timestamp) * 1000).format(
        "Do MMM YYYY [at] hh:mm A",
      );
    }

    return "No validation date available";
  };

  const handleUpdateKyc = async () => {
    // setLoading(true);

    const response = await updateUserKyc(
      "perform kyc",
      subscription,
      companyName,
      publicKey,
      organizationDescription,
      location,
      facilityType,
      scenario,
      quantificationMethodology,
      fuelSource ? fuelSource : "fuelSource",
      renewableEnergySolutions
        ? renewableEnergySolutions
        : "renewableEnergySolutions",
      governmentOrganization
        ? governmentOrganization
        : "governmentOrganization",
      regulatoryStatus ? regulatoryStatus : "regulatoryStatus",
      pathname?.id,
      auth?.token,
    );

    console.log("responseresponse", response);
    if (response?.data?.statusCode === 200) {
      update(ref(db, `kycStatus/${kycKeys[0]}`), {
        status: "completed",
      });
      toast.success("Kyc updated successfully");
    } else if (response?.data?.errorMessage) {
      toast.error(response?.data?.errorMessage);
    } else if (response?.status === 504) {
      toast.error(response?.data?.message);
    } else {
      toast.error("Something went wrong");
    }

    // setLoading(false);
  };

  const handleValidate = async (facility) => {
    setValidateLoading(true);
    let response;
    try {
      if (facility?.isValidated) {
        alert(
          "Validation has already been carried out for this Facility's data",
        );
        setModalOpen(false);
        return;
      } else if (facility?.isRejected) {
        alert("This Facility's data failed Validation or Verification");
        setModalOpen(false);
      } else if (
        facility?.scenario === "infrastructure-change" &&
        selectedSubscriptionPlan === "basic"
      ) {
        response = await facilityValidate(
          selectedId,
          facility?.plantAddress,
          "infrastructure-change",
          "basic",
          auth?.token,
        );
      } else if (
        facility?.scenario === "green" &&
        selectedSubscriptionPlan === "basic"
      ) {
        response = await facilityValidate(
          selectedId,
          facility?.plantAddress,
          "green",
          "basic",
          auth?.token,
        );
      } else if (
        facility?.scenario === "infrastructure-change" &&
        selectedSubscriptionPlan === "governance"
      ) {
        response = await facilityValidate(
          selectedId,
          facility?.plantAddress,
          "infrastructure-change",
          "governance",
          auth?.token,
        );
      } else if (
        facility?.scenario === "green" &&
        selectedSubscriptionPlan === "governance"
      ) {
        console.log(
          "selectedKyc?.subscriptionPlan",
          selectedKyc,
          selectedKyc?.subscriptionPlan,
        );
        response = await facilityValidate(
          selectedId,
          facility?.plantAddress,
          "green",
          "governance",
          auth?.token,
        );
      } else if (facility?.scenario === "carbon-monitoring") {
        response = await facilityValidate(
          selectedId,
          facility?.plantAddress,
          "carbon-monitoring",
          "governance",
          auth?.token,
        );
      } else {
        alert("Invalid Scenario");
        // setLoading(false);
        return;
      }
      console.log("repsonse", response);
      if (response?.data?.statusCode === 200) {
        toast.success("Validation Successful");
        setModalOpen(false);
        setShowForm(false);
        push(ref(db, "notifications"), {
          type: "Validation successful",
          read: false,
          user: selectedId,
          reason,
          timestamp: Date.now(),
        });
        getValidationData();
      } else if (response?.data?.errorMessage) {
        toast.error(response?.data?.errorMessage);
      } else if (response?.data?.message) {
        toast.error(response?.data?.message);
      } else {
        toast.error("Something went wrong");
      }
    } catch (error) {
      console.log("ERROR", error);
      toast.error("Something went wrong");
    }
    setValidateLoading(false);
  };

  if (showForm) {

    
    return (
    <div> </div>
    );
  }

  const kycData = [
    {
      "Facility Name": "GRM Consulting",
      "Facility category": "Green",
      "Sustainability solution": "Green project",
      Plan: "Basic",
    },
  ];
  return (
    <div className="thirdparty_validation">
      <div className="sidebar_container">
        <SideBar />
      </div>
      <div className="main">
        <Search />
        <Tabs
          value={value}
          onChange={handleTabChange}
          aria-label="project tabs"
          className="tab_label_container"
        >
          <Tab
            className={value === 0 ? "tab_label tab_active" : "tab_label"}
            label={
              <div className="tab-label-content">
                <span>perform KYC</span>
                <span className="tab-label-content__count">
                  {kycTotal}
                </span>
              </div>
            }
            {...a11yProps(0)}
          />
          <Tab
            className={value === 1 ? "tab_label tab_active" : "tab_label"}
            label={
              <div className="tab-label-content">
                <span>Unvalidated Projects</span>
                <span className="tab-label-content__count">

                  {/* {greenBasicFacilitiesUnvalidated.length +
                    greenGovernanceFacilitiesUnvalidated.length +
                    infraBasicFacilitiesUnvalidated.length +
                    infraGovernanceFacilitiesUnvalidated.length +
                    monitoringUnvalidated.length} */}
                </span>
              </div>
            }
            {...a11yProps(1)}
          />
          <Tab
            className={value === 2 ? "tab_label tab_active" : "tab_label"}
            label={
              <div className="tab-label-content">
                <span>Validated Projects</span>
                <span className="tab-label-content__count">
                  {/* {greenBasicFacilitiesValidated.length +
                    greenGovernanceFacilitiesValidated.length +
                    infraBasicFacilitiesValidated.length +
                    infraGovernanceFacilitiesValidated.length +
                    monitoringValidated.length} */}
                </span>
              </div>
            }
            {...a11yProps(2)}
          />
        </Tabs>

        <div className="validation-table">
          <div className="validation-table__header">
            <div className="flex gap-3">
              <button
                className={`sub-btn ${
                  facilityType === "green" ? "active" : ""
                }`}
                onClick={() => setFacilityType("green")}
              >
                Green
                <span className="sub-btn__count">
                  { greenFacilities.length
                    }
                </span>
              </button>

              <button
                className={`sub-btn ${
                  facilityType === "non-green" ? "active" : ""
                }`}
                onClick={() => setFacilityType("non-green")}
              >
                Non-green
                <span className="sub-btn__count">
                  {value === 0 ? greenFacilitiesNonGreen.length : 0}
                </span>
              </button>

              <button
                className={`sub-btn ${
                  facilityType === "carbon-monitoring" ? "active" : ""
                }`}
                onClick={() => setFacilityType("carbon-monitoring")}
              >
                Carbon Monitoring
                <span className="sub-btn__count">
                  {value === 0 ? carbonMonitoringData.length : 0}
                </span>
              </button>
            </div>
          </div>

          {!loading &&
            value === 0 &&
            greenBasicFacilitiesUnvalidated?.length === 0 &&
            infraBasicFacilitiesUnvalidated?.length === 0 &&
            greenGovernanceFacilitiesUnvalidated?.length === 0 &&
            infraGovernanceFacilitiesUnvalidated?.length === 0 &&
            monitoringUnvalidated?.length === 0 && (
              <div className="empty_list">
                <img src={Illustration} alt="" />
                <div>No validation data here yet</div>
              </div>
            )}

          {!loading &&
            value === 1 &&
            greenBasicFacilitiesValidated?.length === 0 &&
            infraBasicFacilitiesValidated?.length === 0 &&
            greenGovernanceFacilitiesValidated?.length === 0 &&
            infraGovernanceFacilitiesValidated?.length === 0 &&
            monitoringValidated?.length === 0 && (
              <div className="empty_list">
                <img src={Illustration} alt="" />
                <div>No validation data here yet</div>
              </div>
            )}
          {/* validated project data green */}
          {value === 2 &&
            facilityType === "green" &&
            validatedProjectData?.map((facility, index) => (
              <div className="validation_card">
                <div className="title_group">
                  <div className="card_title">
                    Organisations Name - {facility?.organizationName}
                  </div>
                </div>
                <div className="card_divider"></div>

                <div className="flex gap-[30px] text-[16px]">
                  <div>
                    <div>Facility Name:</div>
                    <div>
                      {facility?.facilityName}
                    </div>
                  </div>
                  <div>
                    <div>Facility category:</div>
                    <div>Green</div>
                  </div>
                  <div>
                    <div>Sustainability solution:</div>
                    <div>Green project</div>
                  </div>
                  <div>
                    <div>Plan</div>
                    <div>Basic</div>
                  </div>

                  <button
                    className="underline ml-20 text-green-700 "
                    onClick={() => handleModalOpen(facility, index, "basic")}
                    disabled={facilityLoading}
                  >
                    {facilityLoading && index === currentIndex
                      ? "Loading..."
                      : "View Document"}
                  </button>
                </div>
                <div></div>
                <div className="confirm">
                  <div className="log">
                    Date of validation:
                    {getLastActivity(facility?.plantAddress)}
                  </div>
                </div>
              </div>
            ))}
          {/* validated project data non-green */}
          {value === 2 &&
            facilityType === "non-green" &&
            validatedProjectDataNonGreen?.map((facility, index) => (
              <div className="validation_card">
                <div className="title_group">
                  <div className="card_title">
                    Organisations Name - {facility?.organizationName}
                  </div>
                </div>
                <div className="card_divider"></div>

                <div className="flex gap-[30px] text-[16px]">
                  <div>
                    <div>Facility Name:</div>
                    <div>
                      {facility?.facilityName }
                    </div>
                  </div>
                  <div>
                    <div>Facility category:</div>
                    <div>Green</div>
                  </div>
                  <div>
                    <div>Sustainability solution:</div>
                    <div>Green project</div>
                  </div>
                  <div>
                    <div>Plan</div>
                    <div>Basic</div>
                  </div>

                  <button
                    className="underline ml-20 text-green-700 "
                    onClick={() => handleModalOpen(facility, index, "basic")}
                    disabled={facilityLoading}
                  >
                    {facilityLoading && index === currentIndex
                      ? "Loading..."
                      : "View Document"}
                  </button>
                </div>
                <div></div>
                <div className="confirm">
                  <div className="log">
                    Date of validation:
                    {getLastActivity(facility?.plantAddress)}
                  </div>
                </div>
              </div>
            ))}
          {/* unvalidated project data */}
          {value === 1 &&
            facilityType === "green" &&
            unvalidatedProjectData?.map((facility, index) => (
              <div className="validation_card">
                <div className="title_group">
                  <div className="text-[16px] text-bold pb-10">
                    {facility?.organizationName}
                  </div>
                </div>
                <hr className=" pb-10"></hr>

                <div className="flex gap-[25px] ">
                  <div>
                    <div className="text-[14px]">Facility Name:</div>
                    <div className="text-gray-600 text-[14px]">
                      {facility?.facilityName}
                    </div>
                  </div>

                  <div>
                    <div className="text-[14px]">Facility category:</div>
                    <div className="text-gray-500 text-[14px]">Green</div>
                  </div>
                  <div>
                    <div className="text-[14px]">Sustainability solution:</div>
                    <div className="text-gray-500 text-[14px]">
                      Green project
                    </div>
                  </div>
                  <div>
                    <div className="text-[14px]">Plan</div>
                    <div className="text-gray-500 text-[14px]">Basic</div>
                  </div>
                  <div className="flex gap-5">
                    <button
                      onClick={() => setShowUploadDocument(true)}
                      className="underline ml-44 text-green-700  text-[14px]"
                    >
                      {facilityLoading && index === currentIndex
                        ? "Loading..."
                        : "Upload document"}
                    </button>

                    <button
                      onClick={() => setShowForm(true)}
                      className="flex items-center justify-center gap-3 px-4 py-2 w-[145px] h-[45px]  
                 rounded-lg text-white font-semibold text-[16px] leading-6 
                 bg-gradient-to-r from-[#038B47] to-[#00AED9] 
                 hover:opacity-90 transition"
                    >
                      Validate
                    </button>
                  </div>
                </div>

                <div className="log">
                  {getLastActivity(facility?.plantAddress)}
                </div>
              </div>
            ))}
          {value === 2 &&
            facilityType === "green" &&
            greenGovernanceFacilitiesValidated?.map((facility, index) => (
              <div className="validation_card">
                <div className="title_group">
                  <div className="card_title">
                    Organisation Name - {facility?.organizationName}
                  </div>
                </div>
                <div className="card_divider"></div>

                <div className="validation_grid">
                  <div>
                    <div>Facility Name:</div>
                    <div>
                      {facility?.organizationName }
                    </div>
                  </div>
                  <div>
                    <div>Facility category:</div>
                    <div>Green</div>
                  </div>
                  <div>
                    <div>Sustainability solution:</div>
                    <div>Green project</div>
                  </div>
                  <div>
                    <div>Plan</div>
                    <div>Governance</div>
                  </div>

                  <button
                    className="confirm-button"
                    onClick={() =>
                      handleModalOpen(facility, index, "governance")
                    }
                    disabled={facilityLoading}
                  >
                    {facilityLoading && index === currentIndex
                      ? "Loading..."
                      : "View Document"}
                  </button>
                </div>

                <div className="confirm">
                  <div>Date of validation</div>
                </div>
              </div>
            ))}
          {value === 0 &&
            facilityType === "green" &&
            greenFacilities?.map((facility, index) => (
              <div className="validation_card">
                <div className="title_group flex justify-between">
                  <div className=" text-[16px] font-bold w-[500px]">
                    Organizational Name - {facility?.greenProjectName}
                  </div>

                  <div>
                    <button
                      type="button"
                      onClick={() => openTabSection(facilityType, index)}
                      aria-expanded={openTabKey === `${facilityType}-${index}`}
                      aria-controls={`kyc-details-${index}`}
                      aria-label={
                        openTabKey === `${facilityType}-${index}`
                          ? "Collapse project details"
                          : "Expand project details"
                      }
                    >
                      <svg
                        className={
                          openTabKey === `${facilityType}-${index}`
                            ? ""
                            : "rotate-180"
                        }
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="12"
                          cy="12"
                          r="12"
                          transform="matrix(1 0 0 -1 0 24)"
                          fill="#D0D5DD"
                        />
                        <path
                          d="M8.66927 13.3333L12.0026 10L15.3359 13.3333"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
                <div className="card_divider"></div>

                <div
                  id={`kyc-details-${index}`}
                  className="validation_grid"
                  style={{
                    display:
                      openTabKey === `${facilityType}-${index}`
                        ? "grid"
                        : "none",
                  }}
                >
                  <div>
                    <div>Facility Name:</div>
                    <div>
                      {facility?.greenProjectName }
                    </div>
                  </div>
                  <div>
                    <div>Facility category:</div>
                    <div>
                      {" "}
                      {facility?.facilityCategory }
                    </div>
                  </div>
                  <div>
                    <div>Sustainability solution:</div>
                    <div>{facility?.nonRenewableEnergySource}</div>
                  </div>
                  <div>
                    <div>Plan</div>
                    <div className="">{facility?.subscriptionPlan}</div>
                  </div>
                  <div className="flex gap-5">
                    <button
  onClick={() => {
    setShowUploadDocument(true);
  }}                      className="underline  text-green-700 text-[14px]"
                      style={{ color: "#038B47" }}
                    >
                      {facilityLoading && index === currentIndex
                        ? "Loading..."
                        : "Upload document"}
                    </button>

                    <Link
                      to={`/admin/upload-validation/${facility?.id}`}
                      className="flex items-center justify-center gap-3 px-4 py-2 w-[145px] h-[45px]  
                 rounded-lg text-white font-semibold text-[16px] leading-6 
                 bg-gradient-to-r from-[#038B47] to-[#00AED9] 
                 hover:opacity-90 transition"
                    >
                      Validate
                    </Link>
                  </div>
                  {/* 
                  <button
                    className="confirm-button"
                    onClick={() => handleModalOpen(facility, index, "governance")}
                    disabled={facilityLoading}
                  >
                    {facilityLoading && index === currentIndex
                      ? "Loading..."
                      : "Validate"}
                  </button> */}
                </div>
              </div>
            ))}
          {value === 0 &&
            facilityType === "carbon-monitoring" &&
            carbonMonitoringData?.map((facility, index) => (
              <div className="validation_card">
                <div className="title_group flex justify-between">
                  <div className=" text-[16px] font-bold w-[500px]">
                    Organizational Name - {facility?.facilityName}
                  </div>

                  <div>
                    <button
                      type="button"
                      onClick={() => openTabSection(facilityType, index)}
                      aria-expanded={openTabKey === `${facilityType}-${index}`}
                      aria-controls={`kyc-details-${index}`}
                      aria-label={
                        openTabKey === `${facilityType}-${index}`
                          ? "Collapse project details"
                          : "Expand project details"
                      }
                    >
                      <svg
                        className={
                          openTabKey === `${facilityType}-${index}`
                            ? ""
                            : "rotate-180"
                        }
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="12"
                          cy="12"
                          r="12"
                          transform="matrix(1 0 0 -1 0 24)"
                          fill="#D0D5DD"
                        />
                        <path
                          d="M8.66927 13.3333L12.0026 10L15.3359 13.3333"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
                <div className="card_divider"></div>

                <div
                  id={`kyc-details-${index}`}
                  className="validation_grid"
                  style={{
                    display:
                      openTabKey === `${facilityType}-${index}`
                        ? "grid"
                        : "none",
                  }}
                >
                  <div>
                    <div>Facility Name:</div>
                    <div>
                      {facility?.facilityName}
                    </div>
                  </div>
                  <div>
                    <div>Facility category:</div>
                    <div>
                      {" "}
                      {facility?.facilityCategory }
                    </div>
                  </div>
                  <div>
                    <div>Sustainability solution:</div>
                    <div>{facility?.nonRenewableEnergySource}</div>
                  </div>
                  <div>
                    <div>Plan</div>
                    <div className="">{facility?.subscriptionPlan}</div>
                  </div>
                  <div className="flex gap-5">
                    <button
                      onClick={() => setShowUploadDocument(true)}
                      className="underline  text-green-700 text-[14px]"
                      style={{ color: "#038B47" }}
                    >
                      {facilityLoading && index === currentIndex
                        ? "Loading..."
                        : "Upload document"}
                    </button>

                    <Link
                      to={`/admin/upload-validation/${facility?.id}`}
                      className="flex items-center justify-center gap-3 px-4 py-2 w-[145px] h-[45px]  
                 rounded-lg text-white font-semibold text-[16px] leading-6 
                 bg-gradient-to-r from-[#038B47] to-[#00AED9] 
                 hover:opacity-90 transition"
                    >
                      Validate
                    </Link>
                  </div>
                  {/* 
                  <button
                    className="confirm-button"
                    onClick={() => handleModalOpen(facility, index, "governance")}
                    disabled={facilityLoading}
                  >
                    {facilityLoading && index === currentIndex
                      ? "Loading..."
                      : "Validate"}
                  </button> */}
                </div>
              </div>
            ))}
          {value === 1 &&
            facilityType === "non-green" &&
            unvalidatedProjectDataNonGreen?.map((facility, index) => (
              <div className="validation_card">
                <div className="title_group">
                  <div className="card_title">
                    Organizational Name - {facility?.organizationName}
                  </div>
                </div>
                <div className="card_divider"></div>

                <div className="validation_grid " style={{ display: "none" }}>
                  <div>
                    <div>Facility Name:</div>
                    <div>
                      {facility?.organizationName }
                    </div>
                  </div>
                  <div>
                    <div>Facility category:</div>
                    <div>{facility?.facilityCategory}</div>
                  </div>
                  <div>
                    <div>Sustainability solution:</div>
                    <div>{facility?.sustainabilitySolution}</div>
                  </div>
                  <div>
                    <div>Plan</div>
                    <div>{facility?.subscriptionPlan}</div>
                  </div>

                  <button
                    className="confirm-button"
                    onClick={() => handleModalOpen(facility, index, "basic")}
                    disabled={facilityLoading}
                  >
                    {facilityLoading && index === currentIndex
                      ? "Loading..."
                      : "View Document"}
                  </button>
                </div>

                <div className="confirm">
                  <div>Date of validation</div>
                </div>
              </div>
            ))}
          {value === 0 &&
            facilityType === "non-green" &&
            greenFacilitiesNonGreen?.map((facility, index) => (
              <div className="validation_card">
                <div className="title_group flex justify-between">
                  <div className="card_title font-bold text-2xl">
                    Organisation Name - {facility?.projectName}
                  </div>

                  <div>
                    <button
                      type="button"
                      onClick={() => openTabSection(facilityType, index)}
                      aria-expanded={openTabKey === `${facilityType}-${index}`}
                      aria-controls={`kyc-details-${index}`}
                      aria-label={
                        openTabKey === `${facilityType}-${index}`
                          ? "Collapse project details"
                          : "Expand project details"
                      }
                    >
                      <svg
                        className={
                          openTabKey === `${facilityType}-${index}`
                            ? ""
                            : "rotate-180"
                        }
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="12"
                          cy="12"
                          r="12"
                          transform="matrix(1 0 0 -1 0 24)"
                          fill="#D0D5DD"
                        />
                        <path
                          d="M8.66927 13.3333L12.0026 10L15.3359 13.3333"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
                <div className="card_divider"></div>

                <div
                  className="validation_grid"
                  style={{
                    display:
                      openTabKey === `${facilityType}-${index}`
                        ? "grid"
                        : "none",
                  }}
                >
                  <div>
                    <div>Facility Name:</div>
                    <div>{facility?.projectName}</div>
                  </div>
                  <div>
                    <div>Facility category:</div>
                    <div> {facility?.projectName}</div>
                  </div>
                  <div>
                    <div>Sustainability solution:</div>
                    <div> {facility?.sustainabilitySolution}</div>
                  </div>
                  <div>
                    <div>Plan</div>
                    <div> {facility?.subscriptionPlan}</div>
                  </div>
                  <div className="flex gap-5">
                    <button
                      onClick={() => setShowUploadDocument(true)}
                      className="underline  text-green-700 text-[14px]"
                      style={{ color: "#038B47" }}
                    >
                      {facilityLoading && index === currentIndex
                        ? "Loading..."
                        : "Upload document"}
                    </button>

                    <Link
                      to={`/admin/upload-validation/${facility?.id}`}
                      className="flex items-center justify-center gap-3 px-4 py-2 w-[145px] h-[45px]  
                 rounded-lg text-white font-semibold text-[16px] leading-6 
                 bg-gradient-to-r from-[#038B47] to-[#00AED9] 
                 hover:opacity-90 transition"
                    >
                      Validate
                    </Link>
                  </div>
                  {/* <button
                    className="confirm-button"
                    onClick={() => handleModalOpen(facility, index, "basic")}
                    disabled={facilityLoading}
                  >
                    {facilityLoading && index === currentIndex
                      ? "Loading..."
                      : "Validate"}
                  </button> */}
                </div>
              </div>
            ))}
          {value === 1 &&
            facilityType === "non-green" &&
            infraGovernanceFacilitiesValidated?.map((facility, index) => (
              <div className="validation_card">
                <div className="title_group">
                  <div className="card_title">
                    Organisation Name - {facility?.organizationName}
                  </div>
                </div>
                <div className="card_divider"></div>

                <div className="validation_grid">
                  <div>
                    <div>Facility Name:</div>
                    <div>
                      {facility?.organizationName }
                    </div>
                  </div>
                  <div>
                    <div>Facility category:</div>
                    <div>{facility?.facilityCategory}</div>
                  </div>
                  <div>
                    <div>Sustainability solution:</div>
                    <div>{facility?.sustainabilitySolution}</div>
                  </div>
                  <div>
                    <div>Plan</div>
                    <div>{facility?.subscriptionPlan}</div>
                  </div>

                  <button
                    className="confirm-button"
                    onClick={() =>
                      handleModalOpen(facility, index, "governance")
                    }
                    disabled={facilityLoading}
                  >
                    {facilityLoading && index === currentIndex
                      ? "Loading..."
                      : "View Document"}
                  </button>
                </div>

                <div className="confirm">
                  <div>Date of validation</div>
                </div>
              </div>
            ))}
          {value === 0 &&
            facilityType === "non-green" &&
            infraGovernanceFacilitiesUnvalidated?.map((facility, index) => (
              <div className="validation_card">
                <div className="title_group">
                  <div className="card_title">
                    Organisation Name - {facility?.organizationName}
                  </div>
                </div>
                <div className="card_divider"></div>

                <div className="validation_grid">
                  <div>
                    <div>Facility Name:</div>
                    <div>
                      {facility?.organizationName }
                    </div>
                  </div>
                  <div>
                    <div>Facility category:</div>
                    <div>Non-green</div>
                  </div>
                  <div>
                    <div>Sustainability solution:</div>
                    <div>Infrastructure change</div>
                  </div>
                  <div>
                    <div>Plan</div>
                    <div>Governance</div>
                  </div>

                  <button
                    className="confirm-button"
                    onClick={() =>
                      handleModalOpen(facility, index, "governance")
                    }
                    disabled={facilityLoading}
                  >
                    {facilityLoading && index === currentIndex
                      ? "Loading..."
                      : "Validate"}
                  </button>
                </div>
              </div>
            ))}
          {value === 1 &&
            facilityType === "non-green" &&
            monitoringValidated?.map((facility, index) => (
              <div className="validation_card">
                <div className="title_group">
                  <div className="card_title">
                    Organisation Name - {facility?.organizationName}
                  </div>
                </div>
                <div className="card_divider"></div>

                <div className="validation_grid">
                  <div>
                    <div>Facility Name:</div>
                    <div>
                      {facility?.organizationName && facility?.organizationName}
                    </div>
                  </div>
                  <div>
                    <div>Facility category:</div>
                    <div>Non-green</div>
                  </div>
                  <div>
                    <div>Sustainability solution:</div>
                    <div>Carbon monitoring</div>
                  </div>
                  <div>
                    <div>Plan</div>
                    <div></div>
                  </div>

                  <button
                    className="confirm-button"
                    onClick={() =>
                      handleModalOpen(facility, index, "governance")
                    }
                    disabled={facilityLoading}
                  >
                    {facilityLoading && index === currentIndex
                      ? "Loading..."
                      : "View Document"}
                  </button>
                </div>
              </div>
            ))}
          {value === 0 &&
            facilityType === "non-green" &&
            monitoringUnvalidated?.map((facility, index) => (
              <div className="validation_card">
                <div className="title_group">
                  <div className="card_title">
                    Organisation Name - {facility?.organizationName}
                  </div>
                </div>
                <div className="card_divider"></div>

                <div className="validation_grid">
                  <div>
                    <div>Facility Name:</div>
                    <div>
                      {facility?.organizationName }
                    </div>
                  </div>
                  <div>
                    <div>Facility category:</div>
                    <div>Non-green</div>
                  </div>
                  <div>
                    <div>Sustainability solution:</div>
                    <div>Carbon monitoring</div>
                  </div>
                </div>

                <div className="confirm">
                  <div>Validate this facility</div>

                  <div>
                    <div></div>
                    <button
                      onClick={() =>
                        handleModalOpen(facility, index, "governance")
                      }
                      disabled={facilityLoading}
                    >
                      {facilityLoading && index === currentIndex
                        ? "Loading..."
                        : "View details"}
                    </button>
                  </div>
                </div>
              </div>
            ))}

          {showUploadDocument && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center mx-auto  justify-center z-50">
              <div className="absolute top-[100px] w-[600px] h-[500px] bg-white rounded-3xl p-6">
                <div
                  className="text-center text-[#101828] text-2xl font-medium mb-6 mt-6"
                  onClick={() => setShowUploadDocument(false)}
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.9965 7.00065H3.82651L8.70651 2.12065C9.09651 1.73065 9.09651 1.09065 8.70651 0.700647C8.61399 0.607943 8.5041 0.534396 8.38313 0.484214C8.26216 0.434033 8.13248 0.408203 8.00151 0.408203C7.87054 0.408203 7.74086 0.434033 7.61988 0.484214C7.49891 0.534396 7.38902 0.607943 7.29651 0.700647L0.706507 7.29065C0.613803 7.38316 0.540256 7.49305 0.490074 7.61402C0.439893 7.735 0.414063 7.86468 0.414062 7.99565C0.414063 8.12662 0.439893 8.2563 0.490074 8.37727C0.540256 8.49824 0.613803 8.60813 0.706507 8.70065L7.29651 15.2906C7.38909 15.3832 7.499 15.4567 7.61996 15.5068C7.74093 15.5569 7.87058 15.5827 8.00151 15.5827C8.13244 15.5827 8.26209 15.5569 8.38305 15.5068C8.50401 15.4567 8.61392 15.3832 8.70651 15.2906C8.79909 15.1981 8.87253 15.0882 8.92263 14.9672C8.97274 14.8462 8.99853 14.7166 8.99853 14.5856C8.99853 14.4547 8.97274 14.3251 8.92263 14.2041C8.87253 14.0831 8.79909 13.9732 8.70651 13.8806L3.82651 9.00065H14.9965C15.5465 9.00065 15.9965 8.55065 15.9965 8.00065C15.9965 7.45065 15.5465 7.00065 14.9965 7.00065Z"
                      fill="black"
                    />
                    Back{" "}
                  </svg>
                </div>
                <div className="text-center text-[#101828] text-2xl font-medium mb-6 mt-6">
                  View Document
                </div>
                <form onSubmit={(e) => e.preventDefault()}>
                  {/* Quantification Methodology Document */}
                  <div className="flex flex-col gap-3 mb-6">
                    <label className="font-semibold text-[#101828] text-base">
                      Quantification Methodology Document
                    </label>

                    {quantificationFile ? (
                      <div className="flex flex-col gap-3 border border-[#038B47] rounded-lg p-3 py-6 w-[552px]">
                        <div className="flex items-center">
                          <div>
                            <img src={pfd} alt="pdf" />
                          </div>
                          <div>
                            <p className="text-[14px] font-medium text-[#101828] pl-5">
                              {quantificationFile.name}
                            </p>
                            <p className="text-[12px] text-gray-500 pl-5">
                              {(quantificationFile.size / 1024 / 1024).toFixed(
                                1,
                              )}
                              MB of 5MB
                            </p>
                          </div>
                          <button
                            type="button"
                            onClick={() => {
                              setQuantificationFile(null);
                              setQuantificationProgress(0);
                            }}
                            aria-label="Remove file"
                            className="ml-auto"
                          >
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M11.9969 13.4008L7.09687 18.3008C6.91354 18.4841 6.68021 18.5758 6.39687 18.5758C6.11354 18.5758 5.88021 18.4841 5.69687 18.3008C5.51354 18.1174 5.42188 17.8841 5.42188 17.6008C5.42188 17.3174 5.51354 17.0841 5.69687 16.9008L10.5969 12.0008L5.69687 7.10078C5.51354 6.91745 5.42188 6.68411 5.42188 6.40078C5.42188 6.11745 5.51354 5.88411 5.69687 5.70078C5.88021 5.51745 6.11354 5.42578 6.39687 5.42578C6.68021 5.42578 6.91354 5.51745 7.09687 5.70078L11.9969 10.6008L16.8969 5.70078C17.0802 5.51745 17.3135 5.42578 17.5969 5.42578C17.8802 5.42578 18.1135 5.51745 18.2969 5.70078C18.4802 5.88411 18.5719 6.11745 18.5719 6.40078C18.5719 6.68411 18.4802 6.91745 18.2969 7.10078L13.3969 12.0008L18.2969 16.9008C18.4802 17.0841 18.5719 17.3174 18.5719 17.6008C18.5719 17.8841 18.4802 18.1174 18.2969 18.3008C18.1135 18.4841 17.8802 18.5758 17.5969 18.5758C17.3135 18.5758 17.0802 18.4841 16.8969 18.3008L11.9969 13.4008Z"
                                fill="#667185"
                              />
                            </svg>
                          </button>
                        </div>

                        {/* Progress bar — monotonic, ends green */}
                        <div className="w-full h-2 bg-[#F9F9F9] rounded">
                          <div
                            className="h-2 bg-[#038B47] rounded transition-all duration-300"
                            style={{ width: `${quantificationProgress}%` }}
                          />
                        </div>
                      </div>
                    ) : (
                      <label className="flex flex-col items-center justify-center border border-dashed border-gray-400 rounded-lg h-[100px] cursor-pointer">
                        <input
                          type="file"
                          className="hidden"
                          onChange={handleQuantificationUpload}
                        />
                        <p className="text-[12px] text-[#101828] text-center mb-2">
                          Choose a file or drag & drop here, max 5MB
                        </p>
                        <svg
                          width="103"
                          height="41"
                          viewBox="0 0 103 41"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="0.5"
                            y="0.5"
                            width="102"
                            height="40"
                            rx="7.5"
                            fill="white"
                          />
                          <rect
                            x="0.5"
                            y="0.5"
                            width="102"
                            height="40"
                            rx="7.5"
                            stroke="#E5E5E5"
                          />
                          <path
                            d="M14.733 26V15.8182H18.2926C19.0019 15.8182 19.5869 15.9408 20.0476 16.1861C20.5083 16.428 20.8513 16.7545 21.0767 17.1655C21.3021 17.5732 21.4148 18.0256 21.4148 18.5227C21.4148 18.9602 21.3369 19.3215 21.1811 19.6065C21.0286 19.8916 20.8265 20.117 20.5746 20.2827C20.326 20.4484 20.0559 20.571 19.7642 20.6506V20.75C20.0758 20.7699 20.389 20.8793 20.7038 21.0781C21.0187 21.277 21.2822 21.562 21.4943 21.9332C21.7064 22.3045 21.8125 22.7585 21.8125 23.2955C21.8125 23.8059 21.6965 24.2649 21.4645 24.6726C21.2325 25.0803 20.8662 25.4034 20.3658 25.642C19.8653 25.8807 19.214 26 18.4119 26H14.733ZM15.9659 24.9062H18.4119C19.2173 24.9062 19.7891 24.7505 20.1271 24.4389C20.4685 24.1241 20.6392 23.7429 20.6392 23.2955C20.6392 22.9508 20.5514 22.6326 20.3757 22.3409C20.2 22.0459 19.9498 21.8106 19.625 21.6349C19.3002 21.456 18.9157 21.3665 18.4716 21.3665H15.9659V24.9062ZM15.9659 20.2926H18.2528C18.6241 20.2926 18.9588 20.2197 19.2571 20.0739C19.5587 19.928 19.7973 19.7225 19.973 19.4574C20.152 19.1922 20.2415 18.8807 20.2415 18.5227C20.2415 18.0753 20.0857 17.6958 19.7741 17.3842C19.4626 17.0694 18.9688 16.9119 18.2926 16.9119H15.9659V20.2926ZM23.6793 26V18.3636H24.8129V19.517H24.8924C25.0316 19.1392 25.2835 18.8326 25.6481 18.5973C26.0127 18.362 26.4237 18.2443 26.881 18.2443C26.9672 18.2443 27.0749 18.246 27.2042 18.2493C27.3335 18.2526 27.4312 18.2576 27.4975 18.2642V19.4574C27.4577 19.4474 27.3666 19.4325 27.2241 19.4126C27.0849 19.3894 26.9374 19.3778 26.7816 19.3778C26.4104 19.3778 26.079 19.4557 25.7873 19.6115C25.4989 19.764 25.2702 19.9761 25.1012 20.2479C24.9355 20.5163 24.8526 20.8229 24.8526 21.1676V26H23.6793ZM31.7582 26.1591C31.0688 26.1591 30.4639 25.995 29.9435 25.6669C29.4265 25.3388 29.0221 24.8797 28.7305 24.2898C28.4421 23.6998 28.2979 23.0104 28.2979 22.2216C28.2979 21.4261 28.4421 20.7318 28.7305 20.1385C29.0221 19.5452 29.4265 19.0845 29.9435 18.7564C30.4639 18.4283 31.0688 18.2642 31.7582 18.2642C32.4476 18.2642 33.0508 18.4283 33.5678 18.7564C34.0882 19.0845 34.4925 19.5452 34.7809 20.1385C35.0726 20.7318 35.2184 21.4261 35.2184 22.2216C35.2184 23.0104 35.0726 23.6998 34.7809 24.2898C34.4925 24.8797 34.0882 25.3388 33.5678 25.6669C33.0508 25.995 32.4476 26.1591 31.7582 26.1591ZM31.7582 25.1051C32.2818 25.1051 32.7127 24.9709 33.0508 24.7024C33.3888 24.4339 33.6391 24.081 33.8015 23.6435C33.9639 23.206 34.0451 22.732 34.0451 22.2216C34.0451 21.7112 33.9639 21.2356 33.8015 20.7947C33.6391 20.3539 33.3888 19.9976 33.0508 19.7259C32.7127 19.4541 32.2818 19.3182 31.7582 19.3182C31.2345 19.3182 30.8036 19.4541 30.4656 19.7259C30.1275 19.9976 29.8772 20.3539 29.7148 20.7947C29.5524 21.2356 29.4712 21.7112 29.4712 22.2216C29.4712 22.732 29.5524 23.206 29.7148 23.6435C29.8772 24.081 30.1275 24.4339 30.4656 24.7024C30.8036 24.9709 31.2345 25.1051 31.7582 25.1051ZM38.4798 26L36.1531 18.3636H37.386L39.0366 24.2102H39.1161L40.7468 18.3636H41.9996L43.6104 24.1903H43.69L45.3406 18.3636H46.5735L44.2468 26H43.0934L41.4229 20.1335H41.3036L39.6332 26H38.4798ZM53.5337 20.0739L52.4798 20.3722C52.4135 20.1965 52.3157 20.0258 52.1864 19.8601C52.0605 19.6911 51.8881 19.5518 51.6694 19.4425C51.4506 19.3331 51.1706 19.2784 50.8292 19.2784C50.3619 19.2784 49.9724 19.3861 49.6609 19.6016C49.3526 19.8137 49.1985 20.0838 49.1985 20.4119C49.1985 20.7036 49.3046 20.9339 49.5167 21.103C49.7288 21.272 50.0603 21.4129 50.511 21.5256L51.6445 21.804C52.3273 21.9697 52.8361 22.2232 53.1708 22.5646C53.5056 22.9027 53.6729 23.3385 53.6729 23.8722C53.6729 24.3097 53.547 24.7008 53.2951 25.0455C53.0465 25.3902 52.6985 25.6619 52.2511 25.8608C51.8036 26.0597 51.2833 26.1591 50.69 26.1591C49.9111 26.1591 49.2665 25.9901 48.756 25.652C48.2456 25.3139 47.9225 24.8201 47.7866 24.1705L48.9002 23.892C49.0063 24.303 49.2068 24.6113 49.5018 24.8168C49.8001 25.0223 50.1895 25.125 50.6701 25.125C51.217 25.125 51.6512 25.009 51.9727 24.777C52.2975 24.5417 52.4599 24.2599 52.4599 23.9318C52.4599 23.6667 52.3671 23.4446 52.1815 23.2656C51.9959 23.0833 51.7108 22.9474 51.3263 22.858L50.0536 22.5597C49.3543 22.3939 48.8406 22.1371 48.5124 21.7891C48.1876 21.4377 48.0252 20.9986 48.0252 20.4716C48.0252 20.0407 48.1462 19.6596 48.3881 19.3281C48.6334 18.9967 48.9665 18.7365 49.3874 18.5476C49.8117 18.3587 50.2923 18.2642 50.8292 18.2642C51.5849 18.2642 52.1781 18.4299 52.609 18.7614C53.0432 19.0928 53.3514 19.5303 53.5337 20.0739ZM58.6408 26.1591C57.905 26.1591 57.2703 25.9967 56.7367 25.6719C56.2064 25.3438 55.7971 24.8864 55.5087 24.2997C55.2237 23.7098 55.0811 23.0237 55.0811 22.2415C55.0811 21.4593 55.2237 20.7699 55.5087 20.1733C55.7971 19.5734 56.1981 19.1061 56.7118 18.7713C57.2289 18.4332 57.8321 18.2642 58.5215 18.2642C58.9192 18.2642 59.312 18.3305 59.6998 18.4631C60.0875 18.5956 60.4405 18.8111 60.7587 19.1094C61.0769 19.4044 61.3304 19.7955 61.5194 20.2827C61.7083 20.7699 61.8027 21.3698 61.8027 22.0824V22.5795H55.9164V21.5653H60.6096C60.6096 21.1345 60.5234 20.75 60.351 20.4119C60.182 20.0739 59.94 19.8071 59.6252 19.6115C59.3136 19.416 58.9457 19.3182 58.5215 19.3182C58.0542 19.3182 57.6498 19.4342 57.3084 19.6662C56.9703 19.8949 56.7102 20.1932 56.5279 20.5611C56.3456 20.929 56.2544 21.3234 56.2544 21.7443V22.4205C56.2544 22.9972 56.3539 23.486 56.5527 23.8871C56.7549 24.2848 57.035 24.5881 57.3929 24.7969C57.7509 25.0024 58.1668 25.1051 58.6408 25.1051C58.949 25.1051 59.2275 25.062 59.476 24.9759C59.7279 24.8864 59.945 24.7538 60.1273 24.5781C60.3096 24.3991 60.4505 24.1771 60.5499 23.9119L61.6834 24.2301C61.5641 24.6146 61.3636 24.9527 61.0819 25.2443C60.8001 25.5327 60.4521 25.758 60.0378 25.9205C59.6235 26.0795 59.1578 26.1591 58.6408 26.1591ZM67.6841 26V15.8182H73.7892V16.9119H68.9171V20.3523H73.3319V21.446H68.9171V26H67.6841ZM75.7418 26V18.3636H76.9151V26H75.7418ZM76.3384 17.0909C76.1097 17.0909 75.9125 17.013 75.7468 16.8572C75.5844 16.7015 75.5032 16.5142 75.5032 16.2955C75.5032 16.0767 75.5844 15.8894 75.7468 15.7337C75.9125 15.5779 76.1097 15.5 76.3384 15.5C76.5671 15.5 76.7627 15.5779 76.9251 15.7337C77.0908 15.8894 77.1737 16.0767 77.1737 16.2955C77.1737 16.5142 77.0908 16.7015 76.9251 16.8572C76.7627 17.013 76.5671 17.0909 76.3384 17.0909ZM80.2374 15.8182V26H79.0641V15.8182H80.2374ZM85.5881 26.1591C84.8523 26.1591 84.2176 25.9967 83.6839 25.6719C83.1536 25.3438 82.7443 24.8864 82.456 24.2997C82.1709 23.7098 82.0284 23.0237 82.0284 22.2415C82.0284 21.4593 82.1709 20.7699 82.456 20.1733C82.7443 19.5734 83.1454 19.1061 83.6591 18.7713C84.1761 18.4332 84.7794 18.2642 85.4688 18.2642C85.8665 18.2642 86.2592 18.3305 86.647 18.4631C87.0348 18.5956 87.3878 18.8111 87.706 19.1094C88.0241 19.4044 88.2777 19.7955 88.4666 20.2827C88.6555 20.7699 88.75 21.3698 88.75 22.0824V22.5795H82.8636V21.5653H87.5568C87.5568 21.1345 87.4706 20.75 87.2983 20.4119C87.1293 20.0739 86.8873 19.8071 86.5724 19.6115C86.2609 19.416 85.893 19.3182 85.4688 19.3182C85.0014 19.3182 84.5971 19.4342 84.2557 19.6662C83.9176 19.8949 83.6574 20.1932 83.4751 20.5611C83.2929 20.929 83.2017 21.3234 83.2017 21.7443V22.4205C83.2017 22.9972 83.3011 23.486 83.5 23.8871C83.7022 24.2848 83.9822 24.5881 84.3402 24.7969C84.6982 25.0024 85.1141 25.1051 85.5881 25.1051C85.8963 25.1051 86.1747 25.062 86.4233 24.9759C86.6752 24.8864 86.8923 24.7538 87.0746 24.5781C87.2569 24.3991 87.3977 24.1771 87.4972 23.9119L88.6307 24.2301C88.5114 24.6146 88.3108 24.9527 88.0291 25.2443C87.7474 25.5327 87.3994 25.758 86.9851 25.9205C86.5708 26.0795 86.1051 26.1591 85.5881 26.1591Z"
                            fill="#898989"
                          />
                        </svg>
                      </label>
                    )}
                  </div>

                  {/* Project Design Document */}
                  <div className="flex flex-col gap-3 mb-6">
                    <label className="font-semibold text-[#101828] text-base">
                      Project Design Document
                    </label>

                    {projectDesignFile ? (
                      <div className="flex flex-col gap-3 border border-[#038B47] rounded-lg p-3 py-6 w-[552px]">
                        <div className="flex items-center">
                          <div>
                            <img src={pfd} alt="pdf" />
                          </div>
                          <div>
                            <p className="text-[14px] font-medium text-[#101828] pl-5">
                              {projectDesignFile.name}
                            </p>
                            <p className="text-[12px] text-gray-500 pl-5">
                              {(projectDesignFile.size / 1024 / 1024).toFixed(
                                1,
                              )}
                              MB of 5MB
                            </p>
                          </div>
                          <button
                            type="button"
                            onClick={() => {
                              setProjectDesignFile(null);
                              setProjectDesignProgress(0);
                            }}
                            aria-label="Remove file"
                            className="ml-auto"
                          >
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M11.9969 13.4008L7.09687 18.3008C6.91354 18.4841 6.68021 18.5758 6.39687 18.5758C6.11354 18.5758 5.88021 18.4841 5.69687 18.3008C5.51354 18.1174 5.42188 17.8841 5.42188 17.6008C5.42188 17.3174 5.51354 17.0841 5.69687 16.9008L10.5969 12.0008L5.69687 7.10078C5.51354 6.91745 5.42188 6.68411 5.42188 6.40078C5.42188 6.11745 5.51354 5.88411 5.69687 5.70078C5.88021 5.51745 6.11354 5.42578 6.39687 5.42578C6.68021 5.42578 6.91354 5.51745 7.09687 5.70078L11.9969 10.6008L16.8969 5.70078C17.0802 5.51745 17.3135 5.42578 17.5969 5.42578C17.8802 5.42578 18.1135 5.51745 18.2969 5.70078C18.4802 5.88411 18.5719 6.11745 18.5719 6.40078C18.5719 6.68411 18.4802 6.91745 18.2969 7.10078L13.3969 12.0008L18.2969 16.9008C18.4802 17.0841 18.5719 17.3174 18.5719 17.6008C18.5719 17.8841 18.4802 18.1174 18.2969 18.3008C18.1135 18.4841 17.8802 18.5758 17.5969 18.5758C17.3135 18.5758 17.0802 18.4841 16.8969 18.3008L11.9969 13.4008Z"
                                fill="#667185"
                              />
                            </svg>
                          </button>
                        </div>

                        {/* Progress bar — monotonic, ends green */}
                        <div className="w-full h-2 bg-[#F9F9F9] rounded">
                          <div
                            className="h-2 bg-[#038B47] rounded transition-all duration-300"
                            style={{ width: `${projectDesignProgress}%` }}
                          />
                        </div>
                      </div>
                    ) : (
                      <label className="flex flex-col items-center justify-center border border-dashed border-gray-400 rounded-lg h-[100px] cursor-pointer">
                        <input
                          type="file"
                          className="hidden"
                          onChange={handleProjectDesignUpload}
                        />
                        <p className="text-[12px] text-[#101828] text-center mb-2">
                          Choose a file or drag & drop here, max 5MB
                        </p>
                        <svg
                          width="103"
                          height="41"
                          viewBox="0 0 103 41"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="0.5"
                            y="0.5"
                            width="102"
                            height="40"
                            rx="7.5"
                            fill="white"
                          />
                          <rect
                            x="0.5"
                            y="0.5"
                            width="102"
                            height="40"
                            rx="7.5"
                            stroke="#E5E5E5"
                          />
                          <path
                            d="M14.733 26V15.8182H18.2926C19.0019 15.8182 19.5869 15.9408 20.0476 16.1861C20.5083 16.428 20.8513 16.7545 21.0767 17.1655C21.3021 17.5732 21.4148 18.0256 21.4148 18.5227C21.4148 18.9602 21.3369 19.3215 21.1811 19.6065C21.0286 19.8916 20.8265 20.117 20.5746 20.2827C20.326 20.4484 20.0559 20.571 19.7642 20.6506V20.75C20.0758 20.7699 20.389 20.8793 20.7038 21.0781C21.0187 21.277 21.2822 21.562 21.4943 21.9332C21.7064 22.3045 21.8125 22.7585 21.8125 23.2955C21.8125 23.8059 21.6965 24.2649 21.4645 24.6726C21.2325 25.0803 20.8662 25.4034 20.3658 25.642C19.8653 25.8807 19.214 26 18.4119 26H14.733ZM15.9659 24.9062H18.4119C19.2173 24.9062 19.7891 24.7505 20.1271 24.4389C20.4685 24.1241 20.6392 23.7429 20.6392 23.2955C20.6392 22.9508 20.5514 22.6326 20.3757 22.3409C20.2 22.0459 19.9498 21.8106 19.625 21.6349C19.3002 21.456 18.9157 21.3665 18.4716 21.3665H15.9659V24.9062ZM15.9659 20.2926H18.2528C18.6241 20.2926 18.9588 20.2197 19.2571 20.0739C19.5587 19.928 19.7973 19.7225 19.973 19.4574C20.152 19.1922 20.2415 18.8807 20.2415 18.5227C20.2415 18.0753 20.0857 17.6958 19.7741 17.3842C19.4626 17.0694 18.9688 16.9119 18.2926 16.9119H15.9659V20.2926ZM23.6793 26V18.3636H24.8129V19.517H24.8924C25.0316 19.1392 25.2835 18.8326 25.6481 18.5973C26.0127 18.362 26.4237 18.2443 26.881 18.2443C26.9672 18.2443 27.0749 18.246 27.2042 18.2493C27.3335 18.2526 27.4312 18.2576 27.4975 18.2642V19.4574C27.4577 19.4474 27.3666 19.4325 27.2241 19.4126C27.0849 19.3894 26.9374 19.3778 26.7816 19.3778C26.4104 19.3778 26.079 19.4557 25.7873 19.6115C25.4989 19.764 25.2702 19.9761 25.1012 20.2479C24.9355 20.5163 24.8526 20.8229 24.8526 21.1676V26H23.6793ZM31.7582 26.1591C31.0688 26.1591 30.4639 25.995 29.9435 25.6669C29.4265 25.3388 29.0221 24.8797 28.7305 24.2898C28.4421 23.6998 28.2979 23.0104 28.2979 22.2216C28.2979 21.4261 28.4421 20.7318 28.7305 20.1385C29.0221 19.5452 29.4265 19.0845 29.9435 18.7564C30.4639 18.4283 31.0688 18.2642 31.7582 18.2642C32.4476 18.2642 33.0508 18.4283 33.5678 18.7564C34.0882 19.0845 34.4925 19.5452 34.7809 20.1385C35.0726 20.7318 35.2184 21.4261 35.2184 22.2216C35.2184 23.0104 35.0726 23.6998 34.7809 24.2898C34.4925 24.8797 34.0882 25.3388 33.5678 25.6669C33.0508 25.995 32.4476 26.1591 31.7582 26.1591ZM31.7582 25.1051C32.2818 25.1051 32.7127 24.9709 33.0508 24.7024C33.3888 24.4339 33.6391 24.081 33.8015 23.6435C33.9639 23.206 34.0451 22.732 34.0451 22.2216C34.0451 21.7112 33.9639 21.2356 33.8015 20.7947C33.6391 20.3539 33.3888 19.9976 33.0508 19.7259C32.7127 19.4541 32.2818 19.3182 31.7582 19.3182C31.2345 19.3182 30.8036 19.4541 30.4656 19.7259C30.1275 19.9976 29.8772 20.3539 29.7148 20.7947C29.5524 21.2356 29.4712 21.7112 29.4712 22.2216C29.4712 22.732 29.5524 23.206 29.7148 23.6435C29.8772 24.081 30.1275 24.4339 30.4656 24.7024C30.8036 24.9709 31.2345 25.1051 31.7582 25.1051ZM38.4798 26L36.1531 18.3636H37.386L39.0366 24.2102H39.1161L40.7468 18.3636H41.9996L43.6104 24.1903H43.69L45.3406 18.3636H46.5735L44.2468 26H43.0934L41.4229 20.1335H41.3036L39.6332 26H38.4798ZM53.5337 20.0739L52.4798 20.3722C52.4135 20.1965 52.3157 20.0258 52.1864 19.8601C52.0605 19.6911 51.8881 19.5518 51.6694 19.4425C51.4506 19.3331 51.1706 19.2784 50.8292 19.2784C50.3619 19.2784 49.9724 19.3861 49.6609 19.6016C49.3526 19.8137 49.1985 20.0838 49.1985 20.4119C49.1985 20.7036 49.3046 20.9339 49.5167 21.103C49.7288 21.272 50.0603 21.4129 50.511 21.5256L51.6445 21.804C52.3273 21.9697 52.8361 22.2232 53.1708 22.5646C53.5056 22.9027 53.6729 23.3385 53.6729 23.8722C53.6729 24.3097 53.547 24.7008 53.2951 25.0455C53.0465 25.3902 52.6985 25.6619 52.2511 25.8608C51.8036 26.0597 51.2833 26.1591 50.69 26.1591C49.9111 26.1591 49.2665 25.9901 48.756 25.652C48.2456 25.3139 47.9225 24.8201 47.7866 24.1705L48.9002 23.892C49.0063 24.303 49.2068 24.6113 49.5018 24.8168C49.8001 25.0223 50.1895 25.125 50.6701 25.125C51.217 25.125 51.6512 25.009 51.9727 24.777C52.2975 24.5417 52.4599 24.2599 52.4599 23.9318C52.4599 23.6667 52.3671 23.4446 52.1815 23.2656C51.9959 23.0833 51.7108 22.9474 51.3263 22.858L50.0536 22.5597C49.3543 22.3939 48.8406 22.1371 48.5124 21.7891C48.1876 21.4377 48.0252 20.9986 48.0252 20.4716C48.0252 20.0407 48.1462 19.6596 48.3881 19.3281C48.6334 18.9967 48.9665 18.7365 49.3874 18.5476C49.8117 18.3587 50.2923 18.2642 50.8292 18.2642C51.5849 18.2642 52.1781 18.4299 52.609 18.7614C53.0432 19.0928 53.3514 19.5303 53.5337 20.0739ZM58.6408 26.1591C57.905 26.1591 57.2703 25.9967 56.7367 25.6719C56.2064 25.3438 55.7971 24.8864 55.5087 24.2997C55.2237 23.7098 55.0811 23.0237 55.0811 22.2415C55.0811 21.4593 55.2237 20.7699 55.5087 20.1733C55.7971 19.5734 56.1981 19.1061 56.7118 18.7713C57.2289 18.4332 57.8321 18.2642 58.5215 18.2642C58.9192 18.2642 59.312 18.3305 59.6998 18.4631C60.0875 18.5956 60.4405 18.8111 60.7587 19.1094C61.0769 19.4044 61.3304 19.7955 61.5194 20.2827C61.7083 20.7699 61.8027 21.3698 61.8027 22.0824V22.5795H55.9164V21.5653H60.6096C60.6096 21.1345 60.5234 20.75 60.351 20.4119C60.182 20.0739 59.94 19.8071 59.6252 19.6115C59.3136 19.416 58.9457 19.3182 58.5215 19.3182C58.0542 19.3182 57.6498 19.4342 57.3084 19.6662C56.9703 19.8949 56.7102 20.1932 56.5279 20.5611C56.3456 20.929 56.2544 21.3234 56.2544 21.7443V22.4205C56.2544 22.9972 56.3539 23.486 56.5527 23.8871C56.7549 24.2848 57.035 24.5881 57.3929 24.7969C57.7509 25.0024 58.1668 25.1051 58.6408 25.1051C58.949 25.1051 59.2275 25.062 59.476 24.9759C59.7279 24.8864 59.945 24.7538 60.1273 24.5781C60.3096 24.3991 60.4505 24.1771 60.5499 23.9119L61.6834 24.2301C61.5641 24.6146 61.3636 24.9527 61.0819 25.2443C60.8001 25.5327 60.4521 25.758 60.0378 25.9205C59.6235 26.0795 59.1578 26.1591 58.6408 26.1591ZM67.6841 26V15.8182H73.7892V16.9119H68.9171V20.3523H73.3319V21.446H68.9171V26H67.6841ZM75.7418 26V18.3636H76.9151V26H75.7418ZM76.3384 17.0909C76.1097 17.0909 75.9125 17.013 75.7468 16.8572C75.5844 16.7015 75.5032 16.5142 75.5032 16.2955C75.5032 16.0767 75.5844 15.8894 75.7468 15.7337C75.9125 15.5779 76.1097 15.5 76.3384 15.5C76.5671 15.5 76.7627 15.5779 76.9251 15.7337C77.0908 15.8894 77.1737 16.0767 77.1737 16.2955C77.1737 16.5142 77.0908 16.7015 76.9251 16.8572C76.7627 17.013 76.5671 17.0909 76.3384 17.0909ZM80.2374 15.8182V26H79.0641V15.8182H80.2374ZM85.5881 26.1591C84.8523 26.1591 84.2176 25.9967 83.6839 25.6719C83.1536 25.3438 82.7443 24.8864 82.456 24.2997C82.1709 23.7098 82.0284 23.0237 82.0284 22.2415C82.0284 21.4593 82.1709 20.7699 82.456 20.1733C82.7443 19.5734 83.1454 19.1061 83.6591 18.7713C84.1761 18.4332 84.7794 18.2642 85.4688 18.2642C85.8665 18.2642 86.2592 18.3305 86.647 18.4631C87.0348 18.5956 87.3878 18.8111 87.706 19.1094C88.0241 19.4044 88.2777 19.7955 88.4666 20.2827C88.6555 20.7699 88.75 21.3698 88.75 22.0824V22.5795H82.8636V21.5653H87.5568C87.5568 21.1345 87.4706 20.75 87.2983 20.4119C87.1293 20.0739 86.8873 19.8071 86.5724 19.6115C86.2609 19.416 85.893 19.3182 85.4688 19.3182C85.0014 19.3182 84.5971 19.4342 84.2557 19.6662C83.9176 19.8949 83.6574 20.1932 83.4751 20.5611C83.2929 20.929 83.2017 21.3234 83.2017 21.7443V22.4205C83.2017 22.9972 83.3011 23.486 83.5 23.8871C83.7022 24.2848 83.9822 24.5881 84.3402 24.7969C84.6982 25.0024 85.1141 25.1051 85.5881 25.1051C85.8963 25.1051 86.1747 25.062 86.4233 24.9759C86.6752 24.8864 86.8923 24.7538 87.0746 24.5781C87.2569 24.3991 87.3977 24.1771 87.4972 23.9119L88.6307 24.2301C88.5114 24.6146 88.3108 24.9527 88.0291 25.2443C87.7474 25.5327 87.3994 25.758 86.9851 25.9205C86.5708 26.0795 86.1051 26.1591 85.5881 26.1591Z"
                            fill="#898989"
                          />
                        </svg>
                      </label>
                    )}
                  </div>

                  <button
                    onClick={() => setShowUploadDocument(false)}
                    type="button"
                    className="w-full py-8 mt-10 bg-gradient-to-r from-[#038B47] to-[#00AED9] rounded-lg text-white font-semibold"
                  >
                    Save
                  </button>
                </form>
              </div>
            </div>
          )}

          {loading && (
            <>
              <div className="category">
                <Skeleton
                  width={120}
                  height={20}
                  borderRadius={8}
                  style={{ marginBottom: "8px" }}
                />
              </div>
              <div className="validation_card">
                <div className="validation_grid">
                  <div>
                    <div>
                      <Skeleton
                        width={"64%"}
                        height={20}
                        borderRadius={8}
                        style={{ marginBottom: "8px" }}
                      />
                    </div>
                    <div>
                      <Skeleton
                        width={"100%"}
                        height={20}
                        borderRadius={8}
                        style={{ marginBottom: "8px" }}
                      />
                    </div>
                  </div>
                  <div>
                    <div>
                      <Skeleton
                        width={"64%"}
                        height={20}
                        borderRadius={8}
                        style={{ marginBottom: "8px" }}
                      />
                    </div>
                    <div>
                      <Skeleton
                        width={"100%"}
                        height={20}
                        borderRadius={8}
                        style={{ marginBottom: "8px" }}
                      />
                    </div>
                  </div>
                  <div>
                    <div>
                      <Skeleton
                        width={"64%"}
                        height={20}
                        borderRadius={8}
                        style={{ marginBottom: "8px" }}
                      />
                    </div>
                    <div>
                      <Skeleton
                        width={"100%"}
                        height={20}
                        borderRadius={8}
                        style={{ marginBottom: "8px" }}
                      />
                    </div>
                  </div>
                </div>

                <div className="log">
                  <Skeleton
                    width={"20%"}
                    height={20}
                    borderRadius={8}
                    style={{ marginBottom: "8px" }}
                  />
                  <Skeleton
                    width="60%"
                    height={20}
                    borderRadius={8}
                    style={{ marginBottom: "8px" }}
                  />
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Validation;
